<template>
  <div class="mb-4">
    <div class="flex py-3 border-b border-solid border-quaternary-400" v-for="i in rows" :key="i">
      <div class="w-1/2 mr-2">
        <skeleton-loader class="mb-0" has-random-width />
      </div>
      <div class="w-1/2">
        <skeleton-loader class="mb-0" has-random-width />
      </div>
    </div>
  </div>
</template>

<script>
import SkeletonLoader from '@/components/ContentLoader/components/SkeletonLoader.vue'

export default {
  name: 'SkeletonList',

  components: {
    SkeletonLoader
  },

  props: {
    rows: {
      type: Number,
      default: 5
    }
  }
}
</script>
